<template>
  <main class="view">
    <div class="english" ref="slider" :style="{ width: width + '%' }">
      <div class="inner">
        <slot name="english"></slot>
      </div>
      <div
        class="slider"
        @mousedown="start"
        @mouseup="stop"
        @touchstart="start"
        @touchend="stop"
        @touchcancel="stop"
      >
        <div class="lang en" @click="fullEnglish">ENGLISH</div>
        <div class="lang cn" @click="fullChinese">中文</div>
      </div>
    </div>
    <div class="chinese">
      <div class="inner">
        <slot name="chinese"></slot>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "split-view",
  data() {
    return {
      resize: false,
    };
  },
  computed: {
    width() {
      return this.$store.state.posX;
    },
  },
  mounted() {
    window.addEventListener("mouseup touchend", this.stop);
  },
  methods: {
    start() {
      this.resize = true;
      window.addEventListener("touchmove", this.touchWidth);
      window.addEventListener("mousemove", this.changeWidth);
    },
    changeWidth(event) {
      if (
        this.resize &&
        event.clientX <= window.innerWidth - 50 &&
        event.clientX > 50
      ) {
        this.$store.state.posX = (event.clientX / window.innerWidth) * 100;
      }
    },
    touchWidth(event) {
      if (
        this.resize &&
        event.touches[0].clientX <= window.innerWidth - 50 &&
        event.touches[0].clientX > 50
      ) {
        this.$store.state.posX =
          (event.touches[0].clientX / window.innerWidth) * 100;
      }
    },
    fullChinese() {
      this.$refs.slider.classList.add("trans");
      this.$store.state.posX = (50 / window.innerWidth) * 100;
      setTimeout(() => {
        this.$refs.slider.classList.remove("trans");
      }, 600);
    },
    fullEnglish() {
      this.$refs.slider.classList.add("trans");
      this.$store.state.posX =
        ((window.innerWidth - 50) / window.innerWidth) * 100;
      setTimeout(() => {
        this.$refs.slider.classList.remove("trans");
      }, 600);
    },
    stop() {
      this.resize = false;
    },
  },
};
</script>

<style lang="scss">
.english,
.chinese {
  width: 100%;
  height: auto;
  user-select: none;
  .inner {
    width: 100%;
    overflow-x: hidden;
  }
  .content {
    max-width: 65ch;
    width: 65ch;
    padding: var(--lh);
    position: relative;
    @media only screen and (max-width: 768px) {
      width: calc(100vw - 50px);
    }
  }
}

.english {
  position: relative;
  top: 0;
  left: 0;
  width: 50%;
  min-height: 100%;
  z-index: 1;
  &.trans {
    transition: width 0.5s;
  }
  h1 {
    line-height: 1.05;
  }
  background: white;
  .inner {
    .image {
      transform: translate(calc(50vw - var(--lh) - 50%), 0);
    }
  }
  .slider {
    position: absolute;
    top: 0;
    right: calc(-0.5 * var(--lh));
    height: 100%;
    width: var(--lh);
    cursor: ew-resize;
    .lang {
      position: absolute;
      top: 50vh;
      left: 50%;
      white-space: nowrap;
      font-size: calc(0.8 * var(--fs));
      padding: calc(0.25 * var(--lh)) calc(0.25 * var(--lh));
      cursor: pointer;
      text-align: right;
      transform-origin: top;
      transform: translate(20%, -50%) rotate(90deg);
      &:hover {
        color: var(--hover);
      }
      &.en {
        left: auto;
        right: 50%;
        transform: translate(10%, -50%) rotate(-90deg);
      }
    }
    &:before {
      content: "";
      position: absolute;
      top: 0;
      left: calc(50% - 1px);
      background: black;
      width: 1px;
      height: 100%;
    }
  }
}
.chinese {
  right: 0;
  position: absolute;
  top: 0;
  // text-align: right;

  .inner {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    header {
      justify-content: flex-end !important;
    }
    .image {
      transform: translate(calc(-50vw + var(--lh) + 50%), 0);
    }
  }
}
</style>
